import { DataTableSkeleton } from '../components/DataTable';
import { STATIONS_COLUMNS, STATIONS_TABLE_MIN_WIDTH } from './StationsTable';

export const StationsTableSkeleton = () => (
  <DataTableSkeleton columns={STATIONS_COLUMNS} rows={6} showLoadingOverlay minWidth={STATIONS_TABLE_MIN_WIDTH} dense />
);

export default StationsTableSkeleton;
